import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  PageWrapper,
  MainWrapper,
  HeadingWrapper,
  MainViewWrapper,
  ListItemWrapper,
  ProfileImageWrapper,
  ButtonsWrapper,
  MainHeading,
  HeadingText,
  IndicatorWrapper,
  IconStyled,
  ButtonStyled,
  ProfileName,
  ProfileImage,
  MainViewContainer,
  LogoStyled,
  ProfileImageContainer
} from "./styles/Styled";
import { InstructionText } from "../EditProfile/styles/Styled";
import ItemSelector from "../../components/MultipleProfiles/EditProfile/ItemSelector/ItemSelector";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import FreeLogo from "../../components/FreeLogo";
import { routes } from "../../routes/routes";
import { showMultiProfileLanguageModal } from "../../utils/multiProfileModalUtils";
import { onChangeUserLanguage } from "../../utils/multipleProfilesUtils";
import { getLanguagesList } from "../../pages/Settings/Settings";
import { config } from "../../config/config";
import { getProfileAvatars, onAddNewProfile } from "../../services/multipleProfilesService";
import { showMultipleProfileErrorModal } from "../../services/modalsService";

const Button = withFocusable(ButtonStyled);

const PROFILE_NAME = "profileName";
const DISPLAY_LANGUAGE = "displayLanguage";
const KIDS_PROFILE = "kidsProfile";

class AddProfile extends React.PureComponent {
  constructor(props) {
    super(props);
    // BLGW-1368 - Start
    // NOTE: - Change the logic, if you change anything in locales array
    const localStorageLanguage = localStorage.getItem("locale");
    const localesIndex =
      localStorageLanguage === "en" ? 0 : localStorageLanguage === "ar" ? 1 : localStorageLanguage === "fr" ? 2 : 0;
    const selectedLanguage = getLanguagesList(config.get().locales)[localesIndex];
    // BLGW-1368 - End
    this.state = {
      profileImage: {
        avatars: [],
        currentAvatar: "",
        selectedAvatar: ""
      },
      profileName: "",
      isKidsProfile: false,
      selectedLanguage: selectedLanguage,
      languageList: getLanguagesList(config.get().locales),
      items: [
        { key: PROFILE_NAME, title: i18n.get("global.editProfile.profileNameCta"), description: "" },
        {
          key: DISPLAY_LANGUAGE,
          title: i18n.get("global.editProfile.displayLangCta"),
          description: (selectedLanguage && selectedLanguage.title) || "English"
        },
        {
          key: KIDS_PROFILE,
          title: i18n.get("pages.settings.parentalControl.kidsProfileHeading"),
          description: i18n.get("pages.addProfile.kidsProfileCtaSubText")
        }
      ],
      profileData: null,
      isLoading: false
    };

    this.onClickProfileName = this.onClickProfileName.bind(this);
    this.showMultiProfileLanguageModal = this.showMultiProfileLanguageModal.bind(this);
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
    this.setAllProfileAvatars = this.setAllProfileAvatars.bind(this);
    this.setProfileData = this.setProfileData.bind(this);
    this.onDiscardChanges = this.onDiscardChanges.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.onUpAddProfileList = this.onUpAddProfileList.bind(this);
  }

  async componentDidMount() {
    const { onRef } = this.props;
    onRef && onRef(this);
    document.addEventListener("keydown", this.keydownHandler);
    try {
      await this.setAllProfileAvatars();
      await this.setProfileData();
    } catch (error) {}
  }

  onClickProfileName() {
    const profileData = {
      ...this.state.profileData,
      profileName: this.state.profileName,
      avatar: this.state.profileImage.currentAvatar,
      language: this.state.selectedLanguage.languageCode
    };
    this.props.history.push({
      pathname: routes.profileName,
      state: {
        backDestination: routes.addProfile,
        profileName: this.state.profileName,
        avatar: this.state.profileImage.currentAvatar,
        profileData: profileData,
        isCallEditAPI: false
      }
    });
  }

  async showMultiProfileLanguageModal() {
    const { languageList, selectedLanguage } = this.state;
    await showMultiProfileLanguageModal.call(this, languageList, selectedLanguage);
  }

  async onChangeLanguage(selectedLanguage, availableLanguages) {
    onChangeUserLanguage.call(this, selectedLanguage, availableLanguages);
  }

  async setAllProfileAvatars() {
    const avatars = await getProfileAvatars();
    const avatarsWithFocusPath = avatars.map((item, index) => ({ src: item, focusPath: `selectedImage_${index}` }));
    this.setState({
      profileImage: {
        ...this.state.profileImage,
        avatars: avatarsWithFocusPath
      }
    });
  }

  async setProfileData() {
    const { location } = this.props;

    const hasHistoryState = !!(location && location.state);
    const profileData = location.state.profileData;
    const profileName = location.state.profileName;
    if (hasHistoryState && profileData) {
      this.setState({
        profileImage: {
          ...this.state.profileImage,
          currentAvatar: profileData.avatar,
          selectedAvatar: profileData.avatar
        },
        profileName: profileName || profileData.profileName,
        profileData: profileData
      });
    }
  }

  onUpAddProfileList(index, focusName) {
    if (index === 0) {
      this.props.setFocus(`selectorItem_${index}_${focusName}`);
    } else {
      this.props.setFocus(`selectorItem_${index - 1}_${focusName}`);
    }
  }
  async onSaveChanges() {
    const { profileName, profileImage, selectedLanguage } = this.state;

    if (!this.state.isLoading) {
      this.setState({ isLoading: true }, async () => {
        try {
          await onAddNewProfile({
            name: profileName,
            avatar: profileImage.currentAvatar,
            language: selectedLanguage.languageCode || selectedLanguage.key,
            category: this.state.isKidsProfile ? "KIDS" : "ADULT",
            userId: localStorage.getItem("globalUserId")
          });
          this.props.stateActions.hideGlobalModal();
          this.setState({ isLoading: false });
          this.props.history.replace({
            pathname: routes.profileSelector
          });
        } catch (e) {
          this.setState({ isLoading: false });
          console.log("==> ~ AddProfile ~ onSaveChanges ~ e:", e);
          showMultipleProfileErrorModal.call(this, "save_passThru");
        }
      });
    }
  }

  onDiscardChanges() {
    const { stateActions, history } = this.props;
    this.setState({}); // Reset state
    stateActions.hideGlobalModal();
    history.replace({
      pathname: routes.profileSelector
    });
  }

  render() {
    const {
      stateActions,
      setFocus,
      pauseNavigation,
      resumeNavigation,
      applicationState: { globalModal, currentFocus }
    } = this.props;
    const { items, isLoading } = this.state;
    return (
      <PageWrapper>
        <LogoStyled>
          <FreeLogo height={"1.968rem"} />
        </LogoStyled>
        <MainWrapper>
          {isLoading && <Loading overlay />}
          <HeadingWrapper>
            <MainHeading fontSize="mediumLarge">
              {i18n.get("global.welcome")} {this.state.profileName}!
            </MainHeading>
            <HeadingText fontSize="default">{i18n.get("pages.addProfile.subHeader")}</HeadingText>
          </HeadingWrapper>
          <MainViewWrapper>
            <MainViewContainer>
              <ListItemWrapper>
                <ItemSelector
                  items={items.map(item => ({
                    item: item,
                    key: item.key,
                    title: item.title,
                    description: item.description
                  }))}
                  stateActions={stateActions}
                  setFocus={setFocus}
                  pauseNavigation={pauseNavigation}
                  resumeNavigation={resumeNavigation}
                  globalModal={globalModal}
                  currentFocus={currentFocus}
                  selectedIndex={0}
                  focusName={"addProfile"}
                  onItemSelected={item => {
                    if (item.key === PROFILE_NAME) {
                      this.onClickProfileName(item);
                    }
                    if (item.key === KIDS_PROFILE) {
                      this.setState({
                        isKidsProfile: !this.state.isKidsProfile
                      });
                    }
                    if (item.key === DISPLAY_LANGUAGE) {
                      this.showMultiProfileLanguageModal();
                    }
                  }}
                  isKidsProfile={this.state.isKidsProfile}
                  onUp={this.onUpAddProfileList}
                />
                <IndicatorWrapper>
                  <IconStyled name="info" iconHeight={"2rem"} iconWidth={"2rem"} />
                  <InstructionText>
                    {i18n.get("pages.addProfile.subTextToModifyProfileViaSettingsPage")}
                  </InstructionText>
                </IndicatorWrapper>
              </ListItemWrapper>
              <ProfileImageWrapper>
                <ProfileImageContainer>
                  <ProfileImage src={this.state.profileImage.currentAvatar} />{" "}
                </ProfileImageContainer>
                <ProfileName>{this.state.profileName}</ProfileName>
              </ProfileImageWrapper>
            </MainViewContainer>
          </MainViewWrapper>
          <ButtonsWrapper direction={i18n.getDirection()}>
            <Button
              label={i18n.get("global.save").toUpperCase()}
              focusPath="save_passThru"
              onEnterPress={() => this.onSaveChanges()}
              onMouseUp={() => this.onSaveChanges()}
              size="small"
              spacing="small"
              displayBlock={true}
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnDown={""}
              dataSnUp={`@selectorItem_${items.length - 1}_addProfile`}
              dataSnLeft={""}
              dataSnRight={"@discard_passThru"}
            />
            <Button
              label={i18n.get("global.discard").toUpperCase()}
              focusPath="discard_passThru"
              onEnterPress={() => this.onDiscardChanges()}
              onMouseUp={() => this.onDiscardChanges()}
              size="small"
              spacing="small"
              displayBlock={true}
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnDown={""}
              dataSnUp={`@selectorItem_${items.length - 1}_addProfile`}
              dataSnLeft={"@save_passThru"}
            />
          </ButtonsWrapper>
        </MainWrapper>
      </PageWrapper>
    );
  }
}

const Component = withAppState(withSubtheme(AddProfile));

export default Component;
